import FlightsSeatsBags from './FlightsSeatsBags';

export default FlightsSeatsBags;
